<h1>
    General Settings
</h1>
<ng-container [formGroup]="generalSettings">
    <div class="form-group">
        <mat-checkbox color="primary" formControlName="playSounds">Play sounds</mat-checkbox>
        <p>This enables sound alerts to play when timer reaches: 60 seconds, 3, 2, 1 and beginning a new round.  </p>
    </div>
</ng-container>